import { Navigate, Route, Routes } from 'react-router-dom';
import { ConfigRules } from './config-rules/ConfigRules';
import { Merchants } from './merchants/Merchants';
import { Products } from './products/Products';
import { RuleDefinitions } from './rule-definitions/RuleDefinitions';
import { TenantHierarchy } from './tenant-hierarchy/TenantHierarchy';
import { TmsContextProvider } from './TmsContext';
import { TmsHeader } from './TmsHeader';
import { Offers } from './offers/Offers';
import { ReferenceData } from './reference-data/ReferenceData';
import { BrandMaster } from './brand/Brand'

export function Tms()
{
    return(
        <>
            <Routes>
                <Route path={'/'} element={<Navigate to={'/tms/tenant-hierarchy'}/>}/>
                <Route path={'/*'} element={<TmsContextProvider><TmsHeader/></TmsContextProvider>}>
                    <Route path={'tenant-hierarchy'} element={<TenantHierarchy/>}/>
                    <Route path={'products'} element={<Products/>}/>
                    <Route path={'merchants'} element={<Merchants/>}/>
                    <Route path={'config-rules'} element={<ConfigRules/>}/>
                    <Route path={'rule-definitions'} element={<RuleDefinitions/>}/>
                    <Route path={'offers'} element={<Offers />} />
                    <Route path={'reference-data'} element={<ReferenceData />} />
                    <Route path={'brand'} element={<BrandMaster />} />
                </Route>
            </Routes>
        </>
    )
}